import SkeletonBar from "../shared/SkeletonBar";

export function OpportunityCardSkeleton() {
    return (
        <article
            className="flex h-full w-full min-w-0 flex-col rounded-2xl border border-slate-200/80 bg-white px-4 py-4 shadow-sm"
            aria-hidden
        >
            <div className="flex items-start justify-between gap-3">
                <div className="min-w-0 flex-1 space-y-2">
                    <SkeletonBar className="h-5 w-4/5 max-w-xs" />
                    <SkeletonBar className="h-3 w-full" />
                    <SkeletonBar className="h-3 w-5/6" />
                    <SkeletonBar className="h-3 w-2/3" />
                </div>
                <div className="shrink-0 space-y-1 text-right">
                    <SkeletonBar className="ms-auto h-6 w-10" />
                    <SkeletonBar className="ms-auto h-2 w-14" />
                </div>
            </div>
            <div className="mt-3 space-y-1.5 border-t border-slate-100/80 pt-2.5">
                <SkeletonBar className="h-2.5 w-16" />
                <SkeletonBar className="h-3 w-full" />
                <SkeletonBar className="h-3 w-4/5" />
            </div>
            <div className="mt-auto flex items-center justify-between gap-3 border-t border-slate-100 pt-3">
                <SkeletonBar className="h-8 w-24 rounded-full" />
                <SkeletonBar className="h-4 w-20" />
            </div>
        </article>
    );
}

export default function OpportunityListSkeletons({
    count = 6,
    className = "",
    label = "Loading trends",
}) {
    return (
        <div
            className={`grid grid-cols-1 items-stretch gap-3 md:grid-cols-2 md:gap-4 ${className}`.trim()}
            aria-busy="true"
            aria-label={label}
            role="status"
        >
            <span className="sr-only">{label}</span>
            {Array.from({ length: count }, (_, index) => (
                <OpportunityCardSkeleton key={index} />
            ))}
        </div>
    );
}
